import { render, staticRenderFns } from "./nav_bMenu.vue?vue&type=template&id=b2e8b752&scoped=true"
import script from "./nav_bMenu.vue?vue&type=script&lang=js"
export * from "./nav_bMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e8b752",
  null
  
)

export default component.exports